import isObject from "lodash/isObject";
import isFunction from "lodash/isFunction";

// The following types are copied from @types/react.

function composeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  return function (instance) {
    refs.forEach(function (ref) {
      if (isFunction(ref)) {
        ref(instance);
      } else if (isObject(ref) && "current" in ref) {
        ref.current = instance;
      }
    });
  };
}
export default composeRefs;